import React from 'react';

const AboutUs = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">About Us</h1>
      <p className="mb-4">
        We are a team dedicated to making your daily commute easier and more efficient. Our Ride Booking App helps users travel between home and office with ease.
      </p>
      <p className="mb-4">
        With a focus on safety, reliability, and user-friendliness, our platform enables seamless ride booking tailored to your schedule and location preferences.
      </p>
      <p>
        Whether you're commuting daily or occasionally, we aim to provide a smooth, affordable, and trustworthy experience.
      </p>
    </div>
  );
};

export default AboutUs;